import * as requestFromServer from '../common/cruds'
import {UserSlices} from './slices'
import {handleNotificationWithToastify} from '../../../app/services/Functional'
import {callTypes, catchError, endCall, startCall} from '../common/slices'

const actions = UserSlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}users/`

export const inspectionOfficerUserLists = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${API_URL}dropdown`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      dispatch(actions.inspectionOfficerUsersList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find users"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const getUserById = (id: string, type: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}${id}/${type}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      const userObj = response.data.data.user
      const userValue = {
        ...userObj,
        group_ids: userObj.users_groups.map((item: any) => item.group_id),
      }
      dispatch(
        actions.user({
          user: userValue,
        })
      )
    })
    .catch((error) => {
      error.clientMessage = "Can't find user"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const createUser = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}`, payload, {
      'Content-Type': 'multipart/form-data',
    })
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      if (!response.data.success && response.data.code === 417) {
        dispatch(actions.setLimitReachedDialog(true))
      } else {
        handleNotificationWithToastify(response.data)
      }
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't create user"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const updateUser = (user: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .patchRequest(`${API_URL}${user.get('id')}`, user, {
      'Content-Type': 'multipart/form-data',
    })
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't update user"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const deleteUser = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .deleteRequest(`${API_URL}${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
    })
    .catch((error) => {
      error.clientMessage = "Can't delete user"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}
export const groupList = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}dropdown`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.inspectionOfficerUsersList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't get users"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const getCompanyUsers = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.list}))
  return requestFromServer
    .getRequest(`${API_URL}company-users-dropdown`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.list}))
      dispatch(actions.companyUsersList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find users"
      dispatch(catchError({error, callType: callTypes.list}))
    })
}

export const handleLimitReachedDialog = (payload: any) => (dispatch: any) => {
  return dispatch(actions.setLimitReachedDialog(payload))
}

export const handleResetUser = () => (dispatch: any) => {
  return dispatch(actions.resetUser())
}